import { CriteriaActions } from "@/helpers/forms/form-criteria-actions";

export class FormCriteriaTransformer {

    static transform(obj) {
        let criteria = {};
        criteria.id = obj.id;
        criteria.parent_id = obj.attributes.parent_id;
        criteria.form_criteria_id = obj.id;
        criteria.display_order = obj.attributes.display_order;
        criteria.field_name = obj.attributes.field_name;
        criteria.field_label = obj.attributes.field_label;
        criteria.mandatory = obj.attributes.mandatory;
        criteria.input_type = obj.attributes.input_type;
        // const options = obj.attributes.input_type_options;
        const options = (obj.attributes.input_type_options || []).map(v => {
            v.action = v.pivot ? v.pivot.action : "";
            delete v.pivot;
            return v;
        });
        criteria.input_type_options = options;
        criteria.disabled = obj.attributes.disabled;
        criteria.values = '';
        switch (criteria.input_type) {
            case CriteriaActions.DROPDOWN:
                options.unshift({text: 'Please select', value: 'please_select'})
                criteria.input_type_options = options;
                if (obj.attributes.values == 0) {
                    // set default value
                    criteria.values = options[0].value;
                } else {
                    // set the value from database
                    criteria.values = obj.attributes.values[0].value;
                }
            break;
            case CriteriaActions.MULTIDROPDOWN:
                if (obj.attributes.values == 0) {
                    criteria.values = [];
                } else {
                    const attributes = [];
                    obj.attributes.values.map(attr => attributes.push(attr.value));
                    criteria.values = attributes;
                }
            break;
            case CriteriaActions.UPLOAD:
                if (obj.attributes.values == 0) {
                    criteria.values = '';
                } else {
                    criteria.values = obj.attributes.values;
                }
            break;
            case CriteriaActions.TEXT:
            case CriteriaActions.TEXT_TAG:
                if (obj.attributes.values.length) {
                    criteria.values = obj.attributes.values[0].custom_value;
                } else {
                    // @jsdecena - Why return obj.attributes.values here (it's an array and a string/text response should not be an array?)
                    // criteria.values = obj.attributes.values;
                    criteria.values = '';
                }
            break;
            case CriteriaActions.STRING:
                if (obj.attributes.values.length) {
                    criteria.values = obj.attributes.values[0].custom_value;
                } else {
                    // @jsdecena - Why return obj.attributes.values here (it's an array and a string/text response should not be an array?)
                    // criteria.values = obj.attributes.values;
                    criteria.values = '';
                }
            break;
            case CriteriaActions.SWITCH_UNIX:
            case CriteriaActions.SWITCH_TAG:
                if (obj.attributes.values.length) {
                    criteria.values = obj.attributes.values[0].custom_value;
                } else {
                    criteria.values = '';
                }
            break;
        }
        criteria.files = (obj.attributes.files !== undefined) ? obj.attributes.files : [];
        return criteria;
    }

    static transformArray(array = []) {
        let data = [];
        array.map(function (item) {
            data.push(FormCriteriaTransformer.transform(item));
        });
        return data;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/forms/form-criteria.transformer.js